import styled from 'styled-components';

export const SelectWrapper = styled.div`
  max-width: 360px;
`;

export const InlineForm = styled.div<{ offsetLeft?: boolean }>`
  display: flex;
  align-items: center;
  ${(props) => props.offsetLeft && 'margin-left: 38px;'}
`;

export const SmallInputWrapper = styled.div`
  &:not(:first-child) {
    margin-left: 20px;
  }

  max-width: 140px;
  display: flex;
  align-items: center;

  .form-tooltip {
    margin-left: 5px;
  }
`;
